module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "tooltip",
      "name": "Tooltip"
    }
  }, [_c('div', {
    staticClass: "bs-example"
  }, [_vm._l((['top', 'left', 'right', 'bottom']), function(place) {
    return _c('tooltip', {
      attrs: {
        "header": "",
        "content": "Lorem ipsum dolor sit amet",
        "placement": place
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_vm._v("Popover on " + _vm._s(place))])])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Trigger")]), _vm._v(" "), _c('p', [_c('tooltip', {
    attrs: {
      "effect": "scale",
      "content": "Lorem ipsum dolor sit amet",
      "placement": "top",
      "trigger": "click"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Click")])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "effect": "scale",
      "content": "Lorem ipsum dolor sit amet",
      "placement": "top",
      "trigger": "contextmenu"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Contextmenu (right click)")])])], 1), _vm._v(" "), _c('tooltip', {
    attrs: {
      "effect": "scale",
      "content": "Lorem ipsum dolor sit amet",
      "placement": "bottom",
      "trigger": "focus"
    }
  }, [_c('bs-input', {
    attrs: {
      "type": "text",
      "placeholder": "Focus"
    }
  })], 1)], 2), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <tooltip effect=\"scale\" placement=\"bottom\" content=\"Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod\">\n      <button class=\"btn btn-default\">tooltip on bottom</button>\n    </tooltip>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("trigger")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of "), _c('code', [_vm._v("click")]), _vm._v(" "), _c('code', [_vm._v("focus")]), _vm._v(" "), _c('code', [_vm._v("hover")]), _vm._v(" "), _c('code', [_vm._v("contextmenu")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("click")])]), _vm._v(" "), _c('p', [_vm._v("How the tooltip is triggered.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("effect")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of "), _c('code', [_vm._v("scale")]), _vm._v(" "), _c('code', [_vm._v("fadein")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("scale")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("content")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("placement")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of "), _c('code', [_vm._v("top")]), _vm._v(" "), _c('code', [_vm._v("left")]), _vm._v(" "), _c('code', [_vm._v("right")]), _vm._v(" "), _c('code', [_vm._v("bottom")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("How to position the tooltip.")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3241b879", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3241b879!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/tooltipDocs.vue
// module id = 280
// module chunks = 0